<template>
  <!-- Navbar -->
  <nav class="main-header navbar navbar-expand bg-white navbar-light border-bottom">
    <screen-loading :show="showLoading" />
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <li class="nav-item">
        <a
          class="nav-link"
          data-widget="pushmenu"
          @click="openNav"
        >
          <i class="fa fa-bars link-pointer" />
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link link-pointer"
          @click="goHomepage"
        >
          <i class="fa fa-home" /> 主頁
        </a>
      </li>
    </ul>
    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto">
      <!-- Messages Dropdown Menu -->
      <li class="nav-item dropdown">
        <a
          class="nav-link"
          data-toggle="dropdown"
          to="/Sample1"
        >
          <i class="fa fa-user-circle-o " />{{ ' ' + username }}
        </a>
      </li>
      <li class="nav-item dropdown">
        <a
          class="nav-link"
          data-toggle="dropdown"
          @click="logout"
        >
          <i
            class="fa fa-sign-out link-pointer"
          />

        <!-- Message End -->
        </a>
      </li>
    </ul>
  </nav>
  <!-- /.navbar -->
</template>

<script>
import ScreenLoading from '../functions/Common/plugins/ScreenLoading'

export default {
  name: 'Header',
  components: {
    ScreenLoading
  },
  data: function () {
    return {
      username: localStorage.getItem('username'),
      user_id: localStorage.getItem('user_id'),
      showLoading: false
    }
  },
  methods: {
    logout () {
      this.showLoading = true
      return this.$store.dispatch('Auth/logout')
        .then(() => {
          this.showLoading = false
          this.$router.push({ name: 'Login' })
        })
        .catch(err => this.throwReject(err))
    },
    openNav () {
      var sidebar = document.getElementById('sidebar')
      if (sidebar.classList.contains('sidebar-collapse')) {
        sidebar.classList.replace('sidebar-collapse', 'sidebar-open')
      } else {
        sidebar.classList.replace('sidebar-open', 'sidebar-collapse')
      }
    },
    closeNav () {
      var sidebar = document.getElementById('sidebar')
      if (!sidebar.classList.contains('sidebar-collapse')) {
        sidebar.classList.replace('sidebar-open', 'sidebar-collapse')
      }
    },
    goHomepage () {
      this.show_loading = true
      this.$router.push({ name: 'Login' }, () => { this.show_loading = false }, () => { this.show_loading = false })
    },
    userEdited () {
      this.username = localStorage.getItem('username')
    }
  }
}
</script>
